import React, { useEffect, useState } from 'react';
import DatePicker, { registerLocale } from "react-datepicker/es";
import { setHours, setMinutes, toDate } from 'date-fns';
import enGB from 'date-fns/locale/en-GB';
import moment from "moment";
import swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';

const MySwal = withReactContent(swal);

export const CloneEventModal = ({ eventData, cloneEvent }) => {
  const [data, setData] = useState({
    name: eventData.name,
    startDate: eventData.startDate,
    endDate: eventData.endDate,
    activationTime: eventData.activationTime,
    salesEndTime: eventData.salesEndTime,
    salesAvailability: 0,
    isAvailableForEarlySells: false,
  });

  const handleChangeDate = (name, value) => {
    setData(prev => ({
      ...prev,
      [name]: value,
    }));
  };

  useEffect(() => {
    registerLocale('en-GB', enGB);
  })

  return (
    <>
      <h2 className="swal2-title">
        Are you sure you want to clone event?
      </h2>
      <div className="swal2-content">
        <div className="add-event__block">
          <label>Event name</label>
          <input
            type="text"
            name="name"
            value={data.name}
            placeholder="Enter event name"
            minLength="3"
            maxLength="500"
            onChange={({ target }) => handleChangeDate(target.name, target.value)}
          />
        </div>

        <div className="add-event__block">
          <label>Start</label>
          <DatePicker
            selected={data.startDate}
            onChange={(value) => handleChangeDate("startDate", value)}
            showTimeSelect
            timeFormat="HH:mm"
            timeIntervals={15}
            dateFormat="d MMM yyyy h:mm a"
            timeCaption="time"
            locale="en-GB"
            maxDate={data.endDate ? toDate(data.endDate) : null}
            minTime={setHours(setMinutes(new Date(), 0), 0)}
            maxTime={data.startDate && data.endDate && moment(data.startDate).dayOfYear() ===  moment(data.endDate).dayOfYear() && moment(data.startDate).year() ===  moment(data.endDate).year()
              ? setHours(setMinutes(new Date(), moment(data.startDate).minute()), moment(data.startDate).hour())
              : setHours(setMinutes(new Date(), 45), 23)
            }
          />
        </div>

        <div className="add-event__block">
          <label>End</label>
          <DatePicker
            selected={data.endDate}
            onChange={(value) => handleChangeDate("endDate", value)}
            showTimeSelect
            timeFormat="HH:mm"
            timeIntervals={15}
            dateFormat="d MMM yyyy h:mm a"
            timeCaption="time"
            locale="en-GB"
            minDate={data.startDate ? toDate(data.startDate) : null}
            minTime={data.startDate && data.endDate && moment(data.startDate).dayOfYear() ===  moment(data.endDate).dayOfYear() && moment(data.startDate).year() ===  moment(data.endDate).year()
              ? setHours(setMinutes(new Date(), moment(data.startDate).minute()), moment(data.startDate).hour())
              : setHours(setMinutes(new Date(), 0), 0)
            }
            maxTime={setHours(setMinutes(new Date(), 45), 23)}
          />
        </div>

        <div className="add-event__block">
          <label>Sales start time</label>

          <DatePicker
            selected={data.activationTime}
            onChange={(value) => handleChangeDate("activationTime", value)}
            timeFormat="HH:mm"
            showTimeSelect
            timeIntervals={15}
            dateFormat="d MMM yyyy h:mm a"
            timeCaption="time"
            placeholderText="Select activation time"
            locale="en-GB"
            maxDate={data.salesEndTime ? toDate(data.salesEndTime) : null}
            minTime={setHours(setMinutes(new Date(), 0), 0)}
            maxTime={data.activationTime && data.salesEndTime && moment(data.activationTime).dayOfYear() ===  moment(data.salesEndTime).dayOfYear() && moment(data.activationTime).year() ===  moment(data.salesEndTime).year()
              ? setHours(setMinutes(new Date(), moment(data.activationTime).minute()), moment(data.activationTime).hour())
              : setHours(setMinutes(new Date(), 45), 23)
            }
          />
        </div>

        <div className="add-event__column">
          <div className="add-event__block">
            <label>Sales end time</label>

            <DatePicker
              selected={data.salesEndTime}
              onChange={(value) => handleChangeDate("salesEndTime", value)}
              timeFormat="HH:mm"
              showTimeSelect
              timeIntervals={15}
              dateFormat="d MMM yyyy h:mm a"
              timeCaption="time"
              placeholderText="Select sales end time"
              minDate={data.activationTime ? toDate(data.activationTime) : null}
              minTime={data.activationTime && data.salesEndTime && moment(data.activationTime).dayOfYear() ===  moment(data.salesEndTime).dayOfYear() && moment(data.activationTime).year() ===  moment(data.salesEndTime).year()
                ? setHours(setMinutes(new Date(), moment(data.activationTime).minute()), moment(data.activationTime).hour())
                : setHours(setMinutes(new Date(), 0), 0)
              }
              maxTime={setHours(setMinutes(new Date(), 45), 23)}
              locale="en-GB"
            />
          </div>
        </div>

      </div>
      <div className="swal2-actions">
        <button
          className="swal2-cancel swal2-styled"
          onClick={() => MySwal.close()}
        >
          Cancel
        </button>
        <button className="swal2-confirm swal2-styled" onClick={() => cloneEvent(data)}>
          Clone
        </button>
      </div>
    </>
  )
}
